module.exports = __webpack_public_path__ + "static/media/v1.cdee68bd.png";